// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"FormWrapper_formWrapper__GI8YC","inputWrapper":"FormWrapper_inputWrapper__W11FZ"};